import { ASSETS_BUCKET, assetFileName, type StorageBucket } from '../../lib/storage';
import { useSignedAssetUrl } from './useSignedAssetUrl';

interface AssetPreviewProps {
  storagePath: string;
  /** `thumb` for the asset grid, `logo` for the brand identity form. */
  variant?: 'thumb' | 'logo';
  /**
   * Which private bucket the key belongs to. Defaults to `assets`, the
   * business's own uploads; AI backdrops live in `rendered-slides`.
   */
  bucket?: StorageBucket;
  /** Overrides the filename-derived alt text where the key is machine noise. */
  label?: string;
}

/** Image preview for a private Storage object, via a short-lived signed URL. */
export function AssetPreview({
  storagePath,
  variant = 'thumb',
  bucket = ASSETS_BUCKET,
  label,
}: AssetPreviewProps) {
  const { url, isLoading, error } = useSignedAssetUrl(storagePath, bucket);
  const className = `asset-preview asset-preview--${variant}`;

  if (isLoading) {
    return (
      <div className={className}>
        <span className="asset-preview__note">Loading</span>
      </div>
    );
  }

  if (error || !url) {
    return (
      <div className={className}>
        <span className="asset-preview__note">Preview unavailable</span>
      </div>
    );
  }

  return (
    <div className={className}>
      <img className="asset-preview__image" src={url} alt={label ?? assetFileName(storagePath)} />
    </div>
  );
}
